import { RoleRights } from '../shared/enums';


const Home = {
    text: 'Home',
    link: '/home',
    icon: 'icon-home'
};

const headingMain = {
    text: 'Navigation',
    heading: true
};

const headingSettings = {
    text: 'Einstellungen',
    roles: [RoleRights.SettingsGet, RoleRights.ClientGet, RoleRights.ClientCreate, RoleRights.GroupsGet, RoleRights.GroupsCreate, RoleRights.UsersGet, RoleRights.UsersCreate],
    heading: true
};

const headingSurveys = {
    text: 'Fragebögen',
    roles: [RoleRights.SurveyGet, RoleRights.SurveyCreate, RoleRights.CategoriesGet, RoleRights.CategoriesCreate],
    heading: true
};

const headingConsultation = {
    text: 'Befragungen',
    roles: [RoleRights.ConsultationGet, RoleRights.ConsultationCreate],
    heading: true
};

const Account = {
    text: 'Account',
    translate: 'menu.ACCOUNT',
    link: '/pages',
    icon: 'icon-user',
    submenu: [
        {
            text: 'Change Password',
            translate: 'menu.CHANGE_PASSWORD',
            link: '/user/userchangepassword'
        }
    ]
};

const Settings = {
    text: 'Verwaltung',
    link: '/settings',
    icon: 'icon-notebook',
    roles: [RoleRights.SettingsGet, RoleRights.ClientGet, RoleRights.ClientCreate, RoleRights.GroupsGet, RoleRights.GroupsCreate, RoleRights.UsersGet, RoleRights.UsersCreate],
    submenu: [
        {
            text: 'Anwendungseinstellungen',
            link: '/settings/settings',
            icon: 'icon-settings',
            roles: [RoleRights.SettingsGet]
        },
        {
            text: 'Manadanten',
            link: '/client',
            roles: [RoleRights.ClientGet, RoleRights.ClientCreate],
            icon: 'fa fa-group',
            submenu: [
                {
                    text: 'Übersicht',
                    link: '/client/clientoverview',
                    roles: [RoleRights.ClientGet]
                },
                {
                    text: 'Hinzufügen',
                    link: '/client/clientadd',
                    roles: [RoleRights.ClientCreate]
                }
            ]
        },
        {
            text: 'Groupmanagement',
            translate: 'menu.GROUPMANAGEMENT',
            roles: [RoleRights.GroupsGet],
            icon: 'icon-people',
            submenu: [
                {
                    text: 'Übersicht',
                    roles: [RoleRights.GroupsGet],
                    translate: 'menu.OVERVIEW',
                    link: '/group/groupoverview'
                },
                {
                    text: 'Hinzufügen',
                    roles: [RoleRights.GroupsCreate],
                    translate: 'menu.ADD',
                    link: '/group/groupadd'
                }
            ]
        },
        {
            text: 'Usermanagement',
            translate: 'menu.USERMANAGEMENT',
            roles: [RoleRights.UsersGet, RoleRights.UsersCreate],
            link: '/user',
            icon: 'icon-user',
            submenu: [
                {
                    text: 'Übersicht',
                    roles: [RoleRights.UsersGet],
                    translate: 'menu.OVERVIEW',
                    link: '/user/useroverview'
                },
                {
                    text: 'Hinzufügen',
                    roles: [RoleRights.UsersCreate],
                    translate: 'menu.ADD',
                    link: '/user/useradd'
                }
            ]
        }
    ]
};

const Survey = {
    text: 'Fragebögen',
    link: '/survey',
    icon: 'icon-chart',
    roles: [RoleRights.SurveyGet, RoleRights.SurveyCreate],
    submenu: [
        {
            text: 'Übersicht',
            translate: 'menu.OVERVIEW',
            link: '/survey/surveyoverview',
            roles: [RoleRights.SurveyGet]

        },
        {
            text: 'Hinzufügen',
            translate: 'menu.ADD',
            link: '/survey/surveyadd',
            roles: [RoleRights.SurveyCreate]
        }
    ]
};

const SurveyCategories = {
    text: 'Kategorien',
    icon: 'icon-layers',
    roles: [RoleRights.CategoriesGet, RoleRights.CategoriesCreate],
    submenu: [
        {
            text: 'Übersicht',
            translate: 'menu.OVERVIEW',
            link: '/survey/categoryoverview',
            roles: [RoleRights.CategoriesGet]
        },
        {
            text: 'Hinzufügen',
            translate: 'menu.ADD',
            link: '/survey/categoryadd',
            roles: [RoleRights.CategoriesCreate]
        }
    ]
};

const Consultation = {
    text: 'Befragungen',
    roles: [RoleRights.ConsultationGet, RoleRights.ConsultationCreate],
    icon: 'icon-bubbles',
    submenu: [
        {
            text: 'Übersicht',
            translate: 'menu.OVERVIEW',
            link: '/consultation/consultationoverview',
            roles: [RoleRights.ConsultationGet]
        },
        {
            text: 'Hinzufügen',
            translate: 'menu.ADD',
            link: '/consultation/consultationadd',
            roles: [RoleRights.ConsultationCreate]
        }
    ]
};
export const menu = [
    headingMain,
    Home,
    Account,
    headingConsultation,
    Consultation,
    headingSurveys,
    Survey,
    SurveyCategories,
    headingSettings,
    Settings
];



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/routes/menu.ts